import { useState, useEffect, useRef } from 'react';
import { Display } from '../../Display/Display';
import s from '../style.module.scss';
import MyIcon from '../../MyIcon';
import { RightOutline, DownOutline } from 'antd-mobile-icons';
import { contentType } from '@/utils/Page/constant';

import { showMobileFileDetail } from '@/utils/Page/search';
const MobileFileSearchDisplay = (props) => {
    let { fileList, needSearch = false, total = 0, type } = props;
    const [expand, setExpand] = useState(false);
    let seconds = useRef(0);
    const timerRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        if (needSearch) {
            if (fileList.length === 0) {
                setIsComplete(true);
                return;
            }

            timerRef.current = setInterval(() => {
                seconds.current += 0.05;
                if (seconds.current === 2) {
                    clearInterval(timerRef.current);
                    return false;
                }
                setCurrentIndex((prev) => {
                    if (prev >= fileList.length - 1) {
                        clearInterval(timerRef.current);
                        setIsComplete(true);
                        return prev;
                    }
                    return prev + 1;
                });
            }, 50);
        } else {
            setIsComplete(true);
        }

        return () => clearInterval(timerRef.current);
    }, [fileList]);
    const toggleExpand = () => {
        setExpand(!expand);
    };
    const onClickItem = (item) => {
        if (type === contentType.web_search) {
            window.open(item.url);
            // props?.clickPageItem(item);
        }
        if (type === contentType.retrieval) {
            let data = {
                type: type,
                ...item
            };
            showMobileFileDetail(data);
        }
    };
    return (
        <div className={s['mobile-file-box']}>
            <Display show={fileList.length > 0 && !isComplete}>
                <div className={s['un-complete']}>
                    <Display show={type === contentType.retrieval}>
                        <div data-text="正在搜索知识资料库" className={`${s['tip-text']} loading-text`}>
                            正在搜索知识资料库：
                        </div>
                    </Display>
                    <Display show={type === contentType.web_search}>
                        <div data-text="正在全网搜索" className={`${s['tip-text']} loading-text`}>
                            正在全网搜索：
                        </div>
                    </Display>

                    <div className={s['current-file']}>
                        <Display show={type === contentType.retrieval}>
                            <MyIcon style={{ color: 'red' }} type="icon-pdf"></MyIcon>
                        </Display>
                        <Display show={type === contentType.web_search}>
                            <img src={fileList[currentIndex].icon} alt="" />
                        </Display>
                        <span className={s['title-wrap']}> {fileList[currentIndex].title}</span>
                    </div>
                </div>
            </Display>
            <Display show={isComplete}>
                <div onClick={toggleExpand} className={s['complete']}>
                    <Display show={type === contentType.retrieval}>
                        <span className={s['total']}> 参考资料</span>
                    </Display>
                    <Display show={type === contentType.web_search}>
                        <span className={s['total']}> 已搜索到{total}个网页</span>
                    </Display>
                    <Display show={!expand}>
                        <RightOutline />
                    </Display>
                    <Display show={expand}>
                        <DownOutline />
                    </Display>
                </div>
            </Display>
            <Display show={expand}>
                <>
                    <div className={s['file-list-box']}>
                        <div className={s['left']}>
                            {/* <ul className={s['mark-ul']}>
                                <li></li>
                            </ul> */}
                            <div className={s['circle-div']}></div>
                            <div className={s['line-div']}></div>
                        </div>
                        <div className={s['file-list']}>
                            {fileList.map((ele, index) => {
                                return (
                                    <div
                                        onClick={() => {
                                            onClickItem(ele);
                                        }}
                                        className={s['file-list-item']}
                                        key={index}
                                    >
                                        <span className={s['index']}>{ele?.tag}.</span>
                                        <span className={s['title']}>{ele.title}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            </Display>
        </div>
    );
};
export default MobileFileSearchDisplay;
